import { render, staticRenderFns } from "./HighlightsPagesContainer.vue?vue&type=template&id=18db973e&"
import script from "./HighlightsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./HighlightsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports